import Logger from '@usb-ui-tools/logger/dist/esm'
// import { GlobalConstants } from '../shared/constants/globals'
import { isOnEnv } from '../config/connections'
import { getOrigin } from './browserutils'

export const instance = '5'
let localProxyLocation = 'onlinebanking.usbank.com'

let isPenTestEnv = false

if (
  typeof window !== 'undefined' &&
  window.location.host.includes('pentest1')
) {
  isPenTestEnv = true
}
if (typeof window !== 'undefined' && window.location.host.includes('digital')) {
  localProxyLocation = 'digitalbanking.us.bank-dns.com'
}

const microappEnv = getOrigin()
const microappLocalEnv = `https://it2-onlinebanking.usbank.com`

export function addLocationOrigin(suffix) {
  if (isPenTestEnv) {
    /* pentest has only one environment */
    return `https://pentest1-${localProxyLocation}${suffix}`
  }
  if (isOnEnv('localhost') || isOnEnv('dev') || isOnEnv('diybillpaydev')) {
    return `${microappLocalEnv}${suffix}`
  }

  return `${microappEnv}${suffix}`
}

// eslint-disable-next-line valid-jsdoc
/**
 * Creates an asset URL map from manifest paths.
 *
 * @typedef {{
 *  [key: string]: string
 * }} Data
 *
 * @type {(data: Data) => Promise<{}>}
 */
export function handleBatchedRequests(urls) {
  return new Promise((resolve, reject) => {
    const newObj = {}

    try {
      Object.keys(urls).forEach(async (key) => {
        try {
          let d = await fetch(urls[key])

          d = d ? await d.json() : ''
          newObj[key] = d ? d['main.js'] : ''
          if (!isOnEnv('prod') && (isOnEnv('it') || isOnEnv('uat'))) {
            if (isPenTestEnv) {
              newObj[
                key
              ] = `https://pentest1-${localProxyLocation}${newObj[key]}`
            } else {
              newObj[key] = `${microappEnv}${newObj[key]}`
            }
          } else if (
            isOnEnv('localhost') ||
            isOnEnv('dev') ||
            isOnEnv('diybillpaydev')
          ) {
            newObj[key] = `${microappLocalEnv}${newObj[key]}`
          } else {
            newObj[key] = `${microappEnv}${newObj[key]}`
          }
          if (Object.keys(newObj).length === Object.keys(urls).length) {
            resolve(newObj)
          }
        } catch (err) {
          if (process.browser) {
            Logger.error({
              eventSource: {
                businessCapability: 'Pay Bills',
                businessFunctionality: 'Bill Pay',
                component: 'BillPay Header Footer MicroApp'
              },

              eventStatus: 'ERROR',
              exception: {
                exceptionCode: '0',
                dumpAnalysis: err,
                severity: 'high',
                exceptionMsg: err?.message
              }
            })
          }
        }
      })
    } catch (err) {
      reject(err)
    }
  })
}
